/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { StoryblokMtaMasterclass } from '@mta/vela-api-types'
import { Plus } from 'lucide-react'
import { useTranslations } from 'next-intl'
import React, { useState } from 'react'
import { AddToBasketWrapper } from '@/components/e-commerce/basket/AddToBasketWrapper'
import { Button } from '@/components/ui/Button'
import { NumberInput } from '@/components/ui/NumberInput'
import { useMasterclassPrice } from '@/hooks/masterclasses/useMasterclassPrice'
import { cn } from '@/utils/css'

/** A description of the available properties for this component. */
type MasterclassAddToBasketProps = {
  /** The masterclass to show the add to basket elements for. */
  masterclass: StoryblokMtaMasterclass

  /** Whether the add to basket functionality is disabled (default: false). */
  disabled?: boolean
}

/**
 * The add to basket element for an MTa Masterclass product page. Provides the user with the ability to switch the masterclass variant
 * they're purchasing, as well as quantity.
 */
const MasterclassAddToBasket: React.FC<MasterclassAddToBasketProps> = ({ masterclass, disabled = false }) => {
  const t = useTranslations('MasterclassAddToBasket')
  const [selectedQuantity, setSelectedQuantity] = useState<number>(1)
  const unitPrice = useMasterclassPrice(masterclass)

  return (
    <div>
      <div className={'flex flex-row items-center gap-6'}>
        <NumberInput onChange={(quantity) => setSelectedQuantity(quantity)} />
        <AddToBasketWrapper
          unitPrice={unitPrice}
          item={{
            productId: masterclass.slug,
            productType: 'masterclass',
            quantity: selectedQuantity,
          }}
        >
          <Button
            icon={<Plus />}
            iconPosition={'left'}
            type={'button'}
            rounded={'full'}
            className={cn('py-3 px-5', 'mta-add-to-cart')}
            disabled={disabled}
          >
            {t('addToBasket')}
          </Button>
        </AddToBasketWrapper>
      </div>
    </div>
  )
}

export { MasterclassAddToBasket }
